import * as z from 'zod'

export const timeSchema = z.object({
  start: z.number(),
  end: z.number(),
})

export function division(num1: number, num2: number) {
  if (num2 === 0) {
    return '0'
  }
  return (num1 / num2).toFixed(2)
}

export const text9px = 'text-[9px] font-sans leading-[14px]'
export const text12px = 'text-[12px] font-sans leading-[18px]'
export const text16px = 'text-[16px] font-sans leading-[26px]'
export const text18px = 'text-[18px] font-sans leading-[28px]'
export const text20px = 'text-[20px] font-sans leading-[28px]'
export const text32px = 'text-[32px] font-sans leading-[42px]'
export const text36px = 'text-[36px] font-sans leading-[48px]'
export const text48px = 'text-[48px] font-sans leading-[68px]'

export const inputDiv = 'bg-white border-[1px] text-[#1D1D1D] border-[#E3E2E5] rounded-[6px] h-[40px]'